export const transformPermissions = (permissions) => {
    if (!Array.isArray(permissions)) return null;
    // if (permissions.length === 0) return {}; // Handled by filtered check below

    const isPermissionObject = (item) =>
        item &&
        typeof item === 'object' &&
        !Array.isArray(item) &&
        typeof item.resource === 'string' &&
        item.resource.trim() !== '' &&
        Array.isArray(item.actions);

    const filtered = permissions.filter(isPermissionObject);

    if (filtered.length === 0) return {};

    const result = Object.fromEntries(
        filtered.map(({ resource, actions }) => [
            resource,
            {
                read: actions.includes('read'),
                write: actions.includes('write'),
                actions, // where is used the object should search action directly in the array
            },
        ]),
    );

    return result;
};

// True when the user's only permission with actions is the given resource.
// Root users and org admins with empty permissions are never considered scoped.
export const hasOnlyPermission = (user, resource) => {
    const isRoot = user?.role === 'root';
    const isOrgAdmin = !user?.userGroupId;
    const hasEmptyPermissions = Array.isArray(user?.permissions) && user.permissions.length === 0;

    if (isRoot || (isOrgAdmin && hasEmptyPermissions)) return false;

    const userPermissions = transformPermissions(user?.permissions);
    if (!userPermissions) return false;

    const resourcesWithActions = Object.entries(userPermissions).filter(([, value]) => value?.actions?.length > 0);

    return resourcesWithActions.length === 1 && resourcesWithActions[0][0] === resource;
};
